export default import.meta.ROLLDOWN_FILE_URL_doU6ovWIBPWSMuQwACyWqw